import { Router } from '@angular/router';
import { IExam } from 'src/app/interface/dto';
import { Component, OnInit } from '@angular/core';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { ExamService } from 'src/app/services/exam-service.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';

@Component({
  selector: 'app-seb-instruction-url',
  templateUrl: './seb-instruction-url.component.html',
  styleUrls: ['./seb-instruction-url.component.scss']
})
export class SebInstructionUrlComponent implements OnInit {

  constructor(private popoverRef: PopoverRef<SebInstructionUrlComponent>, private examService: ExamService, private route: Router, private examSchService: ExamScheduleService) { }
  exam: IExam = examDefault;
  sebInstructionUrl: string;
  async ngOnInit() {
    try {
      if (this.examService.selectedExams?.length === 1) {
        this.exam = this.examService.selectedExams[0];
        const res = await this.examService.getSEBInstructionUrl();
        this.sebInstructionUrl = res["data"];
      }
    }
    catch (error) {
    }

  }

  close() {
    this.popoverRef.close();
  }
}
